import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';
export default function NetworkBasicInfoComponent ({domainDetails,handleInnerFormChange, selectedNetwork}: any) {
  const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedNetwork?.Name}
          />
        
        <InputContainer
                 label="Domain Name"
                 labelField="Name"
                 list={domainDetails}
                 onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'DomainId',
  
                  )
                 }}
                 optionName="Choose Domain"
                 type="select"
                 value={selectedNetwork?.DomainId}
                 valueField="Id"
             />
        <InputContainer

label="OrganizationNetwork"

onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
        'IsOrganizationNetwork',

      )
}}
type="checkbox"
value={selectedNetwork?.IsOrganizationNetwork}
/>

<InputContainer
                 label="Network Type Group"
                 labelField="Text"
                 list={libraryData?.result?.NetworkTypeGroup}
                 onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'NetworkTypeGroupId',
  
                  )
                 }}
                 optionName="Choose NetworkTypeGroup"
                 type="select"
                 value={selectedNetwork?.NetworkTypeGroupId}
                 valueField="Value"
             />
<div className='col-span-full'>
   <InputContainer

label="Description"

onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
       'Description'
       );
}}
type="rte"
value={selectedNetwork?.Description}
/></div>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}